import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../assets/style/common.scss'


let layouts = {

  "_default": () => import('../layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => m.default || m)

}

let resolvedLayouts = {}

export default {
  head: {"title":"Btok","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"format-detection","content":"telephone=no, email=no"},{"name":"description","content":"Btok is an all-in-one blockchain social platform, serving global thousands of blockchain project groups, including Bitcoin, Ethereum, ETH, and Ripple. You can also chat instantly with millions of blockchain users on Btok, participate in activities to receive airdrops, and get the latest bitcoin market and blockchain real-time information. Btok and blockchain exchanges are interconnected, and Btok wallet can support real-time transfer and transaction to meet all the needs of various blockchain users! For details, visit Btok's official website, www.btok.io. "},{"property":"og:description","content":"Btok is an all-in-one blockchain social platform, serving global thousands of blockchain project groups, including Bitcoin, Ethereum, ETH, and Ripple. You can also chat instantly with millions of blockchain users on Btok, participate in activities to receive airdrops, and get the latest bitcoin market and blockchain real-time information. Btok and blockchain exchanges are interconnected, and Btok wallet can support real-time transfer and transaction to meet all the needs of various blockchain users! For details, visit Btok's official website, www.btok.io. "},{"property":"twitter:description","content":"Btok is an all-in-one blockchain social platform, serving global thousands of blockchain project groups, including Bitcoin, Ethereum, ETH, and Ripple. You can also chat instantly with millions of blockchain users on Btok, participate in activities to receive airdrops, and get the latest bitcoin market and blockchain real-time information. Btok and blockchain exchanges are interconnected, and Btok wallet can support real-time transfer and transaction to meet all the needs of various blockchain users! For details, visit Btok's official website, www.btok.io. "}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[{"innerHTML":"\n           a[title~='站长统计'] {\n            display: none;\n          }\n      "}],"script":[{"innerHTML":"\n        var _czc = _czc || [];_czc.push([\"_setAccount\", \"1273324804\"]);\n        (function () {\n            var initFontSize = function () {\n                var _viewportWidth\n                var lock = false\n                var _htmlNode = document.getElementsByTagName('html')[0]\n                var _scrollWidth = screen.availWidth || document.documentElement.scrollWidth\n                var _scrollHeight = (screen.height \u003E 0) ? (window.innerHeight \u003E= screen.height || window.innerHeight == 0) ? screen.height : window.innerHeight : window.innerHeight\n\n                var maxWidth = 750;\n\n                _viewportWidth = _scrollHeight \u003E _scrollWidth ? _scrollWidth : _scrollHeight\n                _htmlNode.style.fontSize = '100px';\n            }\n            initFontSize();\n        })();\n      \n      document.write(unescape(\"%3Cscript%20defer%20src%3D%22https%3A%2F%2Fwww.googletagmanager.com%2Fgtag%2Fjs%3Fid%3DG-HPVP5CPMF6%22%3E%3C%2Fscript%3E\"));\n      console.log(unescape(\"%3Cscript%20defer%20src%3D%22https%3A%2F%2Fwww.googletagmanager.com%2Fgtag%2Fjs%3Fid%3DG-HPVP5CPMF6%22%3E%3C%2Fscript%3E\"))\n       \n      window.dataLayer = window.dataLayer || [];\n      function gtag(){dataLayer.push(arguments);}\n      gtag('js', new Date());\n      gtag('config', 'G-HPVP5CPMF6');\n      "},{"src":"https:\u002F\u002Fg.alicdn.com\u002Fjssdk\u002Fu-link\u002Findex.min.js"}],"__dangerouslyDisableSanitizers":["script","style"]},
  render(h, props) {
    const loadingEl = h('nuxt-loading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      }
    }, [ templateEl ])

    return h('div',{
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    layout: null,
    layoutName: ''
  }),
  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },
  
  mounted () {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  
  methods: {
    
    errorChanged () {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },
    
    setLayout (layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default'
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !(layouts['_' + layout] || resolvedLayouts['_' + layout])) layout = 'default'
      let _layout = '_' + layout
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
      .then((Component) => {
        resolvedLayouts[_layout] = Component
        delete layouts[_layout]
        return resolvedLayouts[_layout]
      })
      .catch((e) => {
        if (this.$nuxt) {
          return this.$nuxt.error({ statusCode: 500, message: e.message })
        }
      })
    }
  },
  components: {
    NuxtLoading
  }
}




// WEBPACK FOOTER //
// ./.nuxt/App.js